import { AppStateFailure } from './app-state.failure.model';
import { FailureType } from './app-state.failure.type';
import { AppStateFailureItemWithErrorCode } from './app-state-errorcode.failure';

export class ApiAppStateFailure extends AppStateFailure {
  public errorCode: number;

  public constructor(
    type: FailureType,
    failures: AppStateFailureItemWithErrorCode[],
    errorCode: number
  ) {
    super(type, failures);
    this.errorCode = errorCode;
  }
}
